var _ellipse, _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesRep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 70,
    viewBox: "0 0 49 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2908,
    cy: 14.2395,
    rx: 12.5643,
    ry: 14.2395,
    fill: "#28345A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.25C0 35.8237 1.74191 33.7475 4.13131 33.326L17.3616 30.9919L20.5217 60.3086H0V38.25Z",
    fill: "#28345A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38.25C49 35.8237 47.2581 33.7475 44.8687 33.326L31.6384 30.9919L28.4783 60.3086H49V38.25Z",
    fill: "#28345A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.3408,
    y: 48.5819,
    width: 12.5643,
    height: 1.67524,
    rx: 0.837619,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 40.792L21.4333 31.5573H27.8168L24.625 40.792Z",
    fill: "#027BC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.626 31.7625L27.8177 60.0824H21.4342L24.626 31.7625Z",
    fill: "#027BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesRep);
export default __webpack_public_path__ + "static/media/salesRep.9f756b4a65c5c3e16d38c231476445ab.svg";
export { ForwardRef as ReactComponent };